"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames5 = _interopRequireDefault(require("classnames"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSwipeable = require("react-swipeable");
var _dictionary = require("@otpusk/json-api/dist/dictionary");
var _Modal = _interopRequireDefault(require("../../../Modal"));
var _arrow = _interopRequireDefault(require("./components/Nav/arrow.svg"));
var _styles = _interopRequireDefault(require("./components/Nav/styles.scss"));
var _styles2 = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var COUNT_THUMBS = 5;
var COUNT_THUMBS_HALF = Math.trunc(COUNT_THUMBS / 2);
var photoMapper = R.addIndex(R.map);
var getRangeThumbPhotosByActiveThumbIndex = function getRangeThumbPhotosByActiveThumbIndex(activeThumbIndex, photos) {
  return [].concat(_toConsumableArray(R.slice(activeThumbIndex - COUNT_THUMBS_HALF, activeThumbIndex, photos)), [photos[activeThumbIndex]], _toConsumableArray(R.slice(R.inc(activeThumbIndex), R.inc(activeThumbIndex) + COUNT_THUMBS_HALF, photos)));
};
var getThumbMedianaIndex = function getThumbMedianaIndex(activeIndex, photos) {
  var isAllowIndex = R.and(Boolean(photos[activeIndex + COUNT_THUMBS_HALF]), Boolean(photos[activeIndex - COUNT_THUMBS_HALF]));
  if (isAllowIndex) {
    return activeIndex;
  }
  return !photos[activeIndex - COUNT_THUMBS_HALF] ? COUNT_THUMBS_HALF : !photos[activeIndex + COUNT_THUMBS_HALF] && R.dec(R.length(photos)) - COUNT_THUMBS_HALF;
};
var ARROW__RIGHT_BUTTON = 'ArrowRight';
var ARROW__LEFT_BUTTON = 'ArrowLeft';
var handleKeyboardPress = function handleKeyboardPress(onKeyDown) {
  return function (event) {
    return R.includes(event.code, [ARROW__RIGHT_BUTTON, ARROW__LEFT_BUTTON]) && onKeyDown(event.code);
  };
};
var SingleGalleryModal = function SingleGalleryModal(_ref) {
  var initialActiveIndex = _ref.initialActiveIndex,
    photos = _ref.photos,
    watermark = _ref.watermark,
    _onClose = _ref.onClose;
  var _useRef = (0, _react.useRef)(matchMedia('(max-width: 767px)')),
    mobileMedia = _useRef.current;
  var _useState = (0, _react.useState)(initialActiveIndex),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  var _useState3 = (0, _react.useState)(getThumbMedianaIndex(initialActiveIndex, photos)),
    _useState4 = _slicedToArray(_useState3, 2),
    activeThumbIndex = _useState4[0],
    setActiveThumbIndex = _useState4[1];
  var handlePrevSlide = (0, _react.useCallback)(function () {
    return setActiveIndex(function (index) {
      return Math.max(0, R.dec(index));
    }), setActiveThumbIndex(function (index) {
      return getThumbMedianaIndex(R.dec(index), photos);
    });
  }, [photos]);
  var handleNextSlide = (0, _react.useCallback)(function () {
    return setActiveIndex(function (index) {
      return Math.min(R.dec(R.length(photos)), R.inc(index));
    }), setActiveThumbIndex(function (index) {
      return getThumbMedianaIndex(R.inc(index), photos);
    });
  }, [photos]);
  var handlePrevThumb = function handlePrevThumb() {
    return setActiveThumbIndex(function (index) {
      return Math.max(COUNT_THUMBS_HALF, index - COUNT_THUMBS - COUNT_THUMBS_HALF);
    });
  };
  var handleNextThumb = function handleNextThumb() {
    return setActiveThumbIndex(function (index) {
      return Math.min(R.dec(R.length(photos)) - COUNT_THUMBS_HALF, index + COUNT_THUMBS + COUNT_THUMBS_HALF);
    });
  };
  var isDisabledPrev = !activeIndex;
  var isDisabledNext = R.inc(activeIndex) === R.length(photos);
  var isDisabledPrevThumb = activeThumbIndex === COUNT_THUMBS_HALF;
  var isDisabledNextThumb = R.inc(activeThumbIndex + COUNT_THUMBS_HALF) === R.length(photos);
  var mainPhoto = (0, _dictionary.getImageUrl)(photos[activeIndex], 'veryLarge', watermark);
  var touchHandlers = (0, _reactSwipeable.useSwipeable)({
    preventDefaultTouchmoveEvent: true,
    onSwipedLeft: handleNextSlide,
    onSwipedRight: handlePrevSlide
  });
  (0, _react.useEffect)(function () {
    var handler = handleKeyboardPress(function (pressedButton) {
      return pressedButton === ARROW__RIGHT_BUTTON ? !isDisabledNext && handleNextSlide() : !isDisabledPrev && handlePrevSlide();
    });
    global.window.addEventListener('keydown', handler);
    return function () {
      global.window.removeEventListener('keydown', handler);
    };
  }, [handleNextSlide, handlePrevSlide, isDisabledNext, isDisabledPrev]);
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    closeIcon: true,
    className: (0, _classnames5.default)(_styles2.default.galleryModal, _styles2.default.singleGalleryModal),
    id: _styles2.default.galleryModalID,
    onClose: function onClose() {
      return _onClose();
    }
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, {
    className: _styles2.default.header
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.goBack,
    dangerouslySetInnerHTML: {
      __html: _arrow.default
    },
    onClick: function onClick() {
      return _onClose();
    }
  }), mobileMedia.matches && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, R.inc(activeIndex), ' / ', R.length(photos))), /*#__PURE__*/_react.default.createElement(_Modal.default.Content, {
    className: _styles2.default.content
  }, mobileMedia.matches ? /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.mobileContainer
  }, /*#__PURE__*/_react.default.createElement("div", _extends({
    className: _styles2.default.mobileImages
  }, touchHandlers), /*#__PURE__*/_react.default.createElement("img", {
    alt: "main-hotel-foto",
    src: mainPhoto
  }))) : /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.singleGalleryContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames5.default)(_styles2.default.singleGalleryControl, _styles2.default.prev, _defineProperty({}, _styles2.default.disabled, isDisabledPrev)),
    dangerouslySetInnerHTML: {
      __html: _arrow.default
    },
    onClick: !isDisabledPrev ? handlePrevSlide : undefined
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.singleGalleryBody
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.singleGalleryImage
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "main-hotel-foto",
    src: mainPhoto
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.singleGalleryCount
  }, R.inc(activeIndex), ' / ', R.length(photos))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.singleGalleryThumbs
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames5.default)(_styles.default.thumbControl, _styles2.default.singleGalleryThumbControl, _styles2.default.prev, _defineProperty({}, _styles2.default.disabled, isDisabledPrevThumb)),
    dangerouslySetInnerHTML: {
      __html: _arrow.default
    },
    onClick: !isDisabledPrevThumb ? handlePrevThumb : undefined
  }), photoMapper(function (photo) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _styles2.default.singleGalleryThumb,
      key: photo,
      style: {
        backgroundImage: "url(\"".concat((0, _dictionary.getImageUrl)(photo, 'small', watermark), "\")")
      },
      onClick: function onClick() {
        return setActiveIndex(R.indexOf(photo, photos));
      }
    });
  }, getRangeThumbPhotosByActiveThumbIndex(activeThumbIndex, photos)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames5.default)(_styles.default.thumbControl, _styles2.default.singleGalleryThumbControl, _styles2.default.next, _defineProperty({}, _styles2.default.disabled, isDisabledNextThumb)),
    dangerouslySetInnerHTML: {
      __html: _arrow.default
    },
    onClick: !isDisabledNextThumb ? handleNextThumb : undefined
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames5.default)(_styles2.default.singleGalleryControl, _styles2.default.next, _defineProperty({}, _styles2.default.disabled, isDisabledNext)),
    dangerouslySetInnerHTML: {
      __html: _arrow.default
    },
    onClick: !isDisabledNext ? handleNextSlide : undefined
  }))));
};
SingleGalleryModal.propTypes = {
  initialActiveIndex: _propTypes.default.number.isRequired,
  photos: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  watermark: _propTypes.default.string.isRequired
};
var _default = exports.default = SingleGalleryModal;